"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rumo": {
    "59b540ba": [{
      "hkey": "55aecd96",
      "slug": "mione-corte-inferiore",
      "name": "Mione-Corte Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "corte-inferiore-ronco": [{
      "hkey": "55aecd96",
      "slug": "mione-corte-inferiore",
      "name": "Mione-Corte Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rumo"
    }],
    "248b4737": [{
      "hkey": "cec67a8d",
      "slug": "rumo",
      "name": "Rumo",
      "primary": true,
      "skipSearch": false
    }],
    "lanza-cenigo": [{
      "hkey": "cec67a8d",
      "slug": "rumo",
      "name": "Rumo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "88461e58": [{
      "hkey": "55aecd96",
      "slug": "mione-corte-inferiore",
      "name": "Mione-Corte Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "mione": [{
      "hkey": "55aecd96",
      "slug": "mione-corte-inferiore",
      "name": "Mione-Corte Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rumo"
    }],
    "3c325a7e": [{
      "hkey": "277c1093",
      "slug": "mocenigo",
      "name": "Mocenigo",
      "primary": true,
      "skipSearch": false
    }],
    "mocenigo-corte-superiore": [{
      "hkey": "277c1093",
      "slug": "mocenigo",
      "name": "Mocenigo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "995cb12e": [{
      "hkey": "cec67a8d",
      "slug": "rumo",
      "name": "Rumo",
      "primary": true,
      "skipSearch": false
    }],
    "scassio": [{
      "hkey": "cec67a8d",
      "slug": "rumo",
      "name": "Rumo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;